import axios from '../axios'

/* 
 * 报考指南、复习计划、相关规范
 */
//查询
export const getListApi = (params) => {
  return axios({
      url: '/exam/agreement/list',
      method: 'get',
      params
  })
}
//详情
export const detailApi = (id) => {
  return axios({
      url: `/exam/agreement/${id}`,
      method: 'get',
      // params
  })
}
// 新增
export const addApi = data => {
  return axios({
      url: '/exam/agreement',
      method: 'post',
      data
  })
}
//更新
export const updateApi = data => {
  return axios({
      url: '/exam/agreement',
      method: 'put',
      data
  })
}
//删除
export const deleteApi= (id) => {
  return axios({
      url: `/exam/agreement/${id}`,
      method: 'delete',
      // params
  })
}



// WEBPACK FOOTER //
// ./src/http/api/xieyi.js